<div class="product-form-container">
  <!-- التنقل بين الأقسام -->
  <div class="tabs">
    <button
      *ngFor="let tab of tabs"
      [class.active]="activeTab === tab.key"
      [class.has-error]="submitted && !isCurrentTabValid()"
      (click)="setActiveTab(tab.key)"
    >
      {{ tab.labelAr }} / {{ tab.labelEn }}
      <span *ngIf="submitted && !isCurrentTabValid()" class="error-indicator">⚠️</span>
    </button>
  </div>

  <form [formGroup]="productForm" class="tab-content">
    
    <!-- =============== Basic Info =============== -->
    <div *ngIf="activeTab === 'basic'" class="section">
      <h2>المعلومات الأساسية</h2>

      <div class="form-group">
        <label>الفئة الرئيسية</label>
        <ng-multiselect-dropdown
          [placeholder]="'اختر الفئة الرئيسية '"
          [settings]="singleDropdownSettings"
          [data]="mainCategories"
          [formControl]="productForm.controls['mainCategoryId']"
          (onSelect)="onMainCategorySelect($event)"
          (onDeSelect)="onMainCategoryDeSelect($event)">
        </ng-multiselect-dropdown>
      </div>

      <div class="form-group">
        <label>الفئات الفرعية (يمكن اختيار أكثر من واحدة)</label>
        <ng-multiselect-dropdown
          [placeholder]="'اختر الفئات الفرعية'"
          [settings]="multiDropdownSettings"
          [data]="subCategories"
          [formControl]="productForm.controls['subCategoryIds']"
          (onSelect)="onSubCategorySelect($event)"
          (onDeSelect)="onSubCategoryDeSelect($event)">
        </ng-multiselect-dropdown>
        <small class="form-text">يمكنك اختيار أكثر من فئة فرعية</small>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Parent ID</label>
          <input 
            type="number" 
            formControlName="parentId" 
            placeholder="أدخل Parent ID (اختياري)"
            min="0"
          />
          <small class="form-text">هذا الحقل اختياري - اتركه فارغاً إذا لم يكن هناك منتج أب</small>
        </div>

        <div class="form-group">
          <label>البراند</label>
          <ng-multiselect-dropdown
            [placeholder]="'اختر البراند '"
            [settings]="singleDropdownSettings"
            [data]="brands"
            [formControl]="productForm.controls['brandId']"
            (onSelect)="onBrandSelect($event)"
            (onDeSelect)="onBrandDeSelect($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>

      <div class="grid two">
        
        <div class="form-group">
          <label>عدد المبيعات</label>
          <input type="number" formControlName="numOfSale" min="0" />
        </div>

        <div class="switch-card">
          <div class="switch-info">
            <div class="switch-icon">✅</div>
            <div>
              <label class="switch-label">الحالة</label>
              <small>تفعيل أو إيقاف ظهور المنتج</small>
            </div>
          </div>

          <label class="switch modern-switch">
            <input type="checkbox" formControlName="status" />
            <span></span>
          </label>
        </div>

        <div class="switch-card">
          <div class="switch-info">
            <div class="switch-icon">🔥</div>
            <div>
              <label class="switch-label">الأفضل مبيعًا</label>
              <small>تمييز المنتج ضمن المنتجات الأكثر مبيعًا</small>
            </div>
          </div>

          <label class="switch modern-switch">
            <input type="checkbox" formControlName="isBestSeller" />
            <span></span>
          </label>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group" [class.error]="isFieldInvalid('branchId')">
          <label>الفرع *</label>
          <select formControlName="branchId">
            <option *ngFor="let branch of branches" [value]="branch.id">
              {{ branch.name }}
            </option>
          </select>
          <div class="error-message" *ngIf="isFieldInvalid('branchId')">
            ⚠️ {{ getFieldError('branchId') }}
          </div>
        </div>

        <div class="form-group" [class.error]="isFieldInvalid('sellerId')">
          <label>البائع *</label>
          <select formControlName="sellerId">
            <option *ngFor="let seller of sellers" [value]="seller.id">
              {{ seller.name }}
            </option>
          </select>
          <div class="error-message" *ngIf="isFieldInvalid('sellerId')">
            ⚠️ {{ getFieldError('sellerId') }}
          </div>
        </div>
      </div>

      <div class="form-group" [class.error]="isFieldInvalid('storeId')">
        <label>المتجر *</label>
        <select formControlName="storeId">
          <option *ngFor="let store of stores" [value]="store.id">
            {{ store.name }}
          </option>
        </select>
        <div class="error-message" *ngIf="isFieldInvalid('storeId')">
          ⚠️ {{ getFieldError('storeId') }}
        </div>
      </div>

      <!-- الأسماء والوصف باللغات -->
      <div class="language-section">
        <h3>الاسم والوصف</h3>
        <!-- Arabic -->
        <div class="form-group">
          <label>اسم المنتج (عربي) *</label>
          <input type="text" formControlName="arName" placeholder="اسم المنتج بالعربية" />
          <div class="error-message" *ngIf="isFieldInvalid('arName')">
            ⚠️ {{ getFieldError('arName') }}
          </div>
        </div>

        <div class="form-group">
          <label>الوصف (عربي)</label>
          <textarea formControlName="arDescription" rows="4" placeholder="الوصف بالعربية"></textarea>
        </div>

        <!-- English -->
        <div class="form-group">
          <label>Product Name (English) *</label>
          <input type="text" formControlName="enName" placeholder="Product name in English" />
          <div class="error-message" *ngIf="isFieldInvalid('enName')">
            ⚠️ {{ getFieldError('enName') }}
          </div>
        </div>

        <div class="form-group">
          <label>Description (English)</label>
          <textarea formControlName="enDescription" rows="4" placeholder="Description in English"></textarea>
        </div>
      </div>

      <div class="form-row">
        <div class="form-checkbox">
          <label>
            <input type="checkbox" formControlName="published" />
            منشور؟
          </label>
        </div>

        <div class="form-checkbox">
          <label>
            <input type="checkbox" formControlName="approved" />
            مُعتمد؟
          </label>
        </div>

        <div class="form-checkbox">
          <label>
            <input type="checkbox" formControlName="isFeatured" />
            منتج مميز؟
          </label>
        </div>

        <div class="form-checkbox">
          <label>
            <input type="checkbox" formControlName="isTodaysDeal" />
            عرض اليوم؟
          </label>
        </div>
      </div>
    </div>

    <!-- =============== PRICE & STOCK =============== -->
    <div *ngIf="activeTab === 'price'" class="section">
      <h2>Price & Stock</h2>

      <div class="form-row">
        <div class="form-group" [class.error]="isFieldInvalid('purchasePrice')">
          <label>سعر الشراء *</label>
          <input 
            type="number" 
            formControlName="purchasePrice" 
            min="0" 
            step="0.01" 
            placeholder="0.00" 
          />
          <div class="error-message" *ngIf="isFieldInvalid('purchasePrice')">
            ⚠️ {{ getFieldError('purchasePrice') }}
          </div>
        </div>

        <div class="form-group" [class.error]="isFieldInvalid('sellingPrice')">
          <label>سعر البيع *</label>
          <input 
            type="number" 
            formControlName="sellingPrice" 
            min="0" 
            step="0.01" 
            placeholder="0.00" 
          />
          <div class="error-message" *ngIf="isFieldInvalid('sellingPrice')">
            ⚠️ {{ getFieldError('sellingPrice') }}
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group" [class.error]="isFieldInvalid('sku')">
          <label>SKU *</label>
          <input 
            type="text" 
            formControlName="sku" 
            placeholder="أدخل SKU" 
          />
          <div class="error-message" *ngIf="isFieldInvalid('sku')">
            ⚠️ {{ getFieldError('sku') }}
          </div>
        </div>

        <div class="form-group" [class.error]="isFieldInvalid('barcode')">
          <label>الباركود *</label>
          <input type="text" formControlName="barcode" placeholder="أدخل الباركود" />
          <div class="error-message" *ngIf="isFieldInvalid('barcode')">
            ⚠️ {{ getFieldError('barcode') }}
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group" [class.error]="isFieldInvalid('barcodeType')">
          <label>barcodeType *</label>
          <input 
            type="text" 
            formControlName="barcodeType" 
            placeholder="أدخل barcodeType 0/1" 
          />
          <div class="error-message" *ngIf="isFieldInvalid('barcodeType')">
            ⚠️ {{ getFieldError('barcodeType') }}
          </div>
        </div>

        <div class="form-group" [class.error]="isFieldInvalid('unitFactor')">
          <label>unitFactor *</label>
          <input 
            type="text" 
            formControlName="unitFactor" 
            placeholder="أدخل unitFactor x num" 
          />
          <div class="error-message" *ngIf="isFieldInvalid('unitFactor')">
            ⚠️ {{ getFieldError('unitFactor') }}
          </div>
        </div>
      </div>

      <!-- إدارة المخزون -->
      <div class="stock-management">
        <h3>إدارة المخزون</h3>
        <div formArrayName="stocks">
          <div *ngFor="let stock of stocks.controls; let i = index" [formGroupName]="i" class="stock-item">
            <div class="form-row">
              <div class="form-group">
                <label>المتجر</label>
                <select formControlName="storeId">
                  <option *ngFor="let store of stores" [value]="store.id">
                    {{ store.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>الكمية</label>
                <input type="number" formControlName="quantity" min="0" placeholder="0" />
              </div>
              <div class="form-group ">
                <label>السعر</label>
                <input type="number" formControlName="price" min="0" placeholder="0" />
              </div>
              <div class="form-group">
                <button type="button" class="btn-remove" style="max-width: 33%;" (click)="removeStock(i)" [disabled]="stocks.length < 2">
                  حذف
                </button>
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="btn-add" (click)="addStock()">
          + إضافة مخزن
        </button>
      </div>

      <div class="form-row">
        <div class="form-group" [class.error]="isFieldInvalid('minPurchaseQty')">
          <label>أقل عدد يمكن شراؤه*</label>
          <input 
            type="number" 
            formControlName="minPurchaseQty" 
            min="0" 
            step="1" 
            placeholder="1" 
          />
          <div class="error-message" *ngIf="isFieldInvalid('minPurchaseQty')">
            ⚠️ {{ getFieldError('minPurchaseQty') }}
          </div>
        </div>

        <div class="form-group" [class.error]="isFieldInvalid('weightKg')">
          <label>*وزن الوحدة</label>
          <input 
            type="number" 
            formControlName="weightKg" 
            min="0" 
            step="0.125" 
            placeholder="0.00" 
          />
          <div class="error-message" *ngIf="isFieldInvalid('weightKg')">
            ⚠️ {{ getFieldError('weightKg') }}
          </div>
        </div>
      </div>
        <div class="grid two">
        <div class="form-group" [class.invalid]="isFieldInvalid('discount')">
          <label>الخصم</label>

          <div class="percent-input">
            <input
              type="text"
              formControlName="discount"
              placeholder="0"
              min="0"
              max="100"
            />
            <span>%</span>
          </div>

          <small class="error" *ngIf="isFieldInvalid('discount')">
            {{ getFieldError('discount') }}
          </small>
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('maxPurchaseQty')">
          <label>أقصي كمية شراء *</label>

          <input type="number" formControlName="maxPurchaseQty" min="0" />

          <small class="error" *ngIf="isFieldInvalid('maxPurchaseQty')">
            {{ getFieldError('maxPurchaseQty') }}
          </small>
        </div>
      </div>

      <div class="form-group" [class.error]="isFieldInvalid('unitId')">
        <label>الوحدة *</label>
        <select formControlName="unitId">
          <option *ngFor="let unit of units" [value]="unit.id">
            {{ unit.name }}
          </option>
        </select>
        <div class="error-message" *ngIf="isFieldInvalid('unitId')">
          ⚠️ {{ getFieldError('unitId') }}
        </div>
      </div>
    </div>

    
    <!-- =============== FILES & MEDIA =============== -->
    <div *ngIf="activeTab === 'media'" class="section">
      <h2>Files & Media</h2>

      <div class="media-box">
        <h3>صور المنتج</h3>

        <div class="form-group">
          <label>Photo IDs</label>
          <input
            type="text"
            formControlName="photosIdsText"
            placeholder="مثال: 1,5,9"
            readonly
          />
          <small class="hint">
            اختر صورة أو أكثر من الجاليري، وسيتم إرسالها باسم photos_ids.
          </small>
        </div>

        <button type="button" class="btn-add" (click)="openGalleryModal()">
          🖼️ اختيار من الجاليري
        </button>

        <div class="selected-images" *ngIf="selectedPhotos.length > 0">
          <div class="selected-image-card" *ngFor="let photo of selectedPhotos">
            <img
              [src]="photo.url | ImageUrlPipe"
              [alt]="photo.name"
              appImageFallback
            />

            <div class="selected-image-info">
              <span>{{ photo.name }}</span>
              <small>ID: {{ photo.id }}</small>
            </div>

            <button type="button" class="btn-remove" (click)="removeSelectedPhoto(photo)">
              حذف
            </button>
          </div>
        </div>
      </div>

      <app-gallery-picker
        *ngIf="isGalleryModalOpen"
        [selectedImages]="selectedPhotos"
        (selectedImagesChange)="onGalleryImagesChange($event)"
        (close)="closeGalleryModal()">
      </app-gallery-picker>

      <!-- =============== VARIANTS =============== -->
      <h2>المتغيرات</h2>

      <div class="form-group" [class.error]="isFieldInvalid('variantId')">
        <label>variant *</label>
        <select formControlName="variantId">
          <option *ngFor="let variant of variants" [value]="variant.id">
            {{ variant.name }}
          </option>
        </select>
        <div class="error-message" *ngIf="isFieldInvalid('variantId')">
          ⚠️ {{ getFieldError('variantId') }}
        </div>
      </div>
      
      <!-- =============== SEO =============== -->
      <h2>SEO</h2>

      <div class="form-group">
        <label>Slug (رابط المنتج)</label>
        <input type="text" formControlName="slug" placeholder="product-name" />
      </div>

      <div class="form-group">
          <label>Video Url</label>
          <input type="text" formControlName="video_link" placeholder="Video-Url" />
        </div>
    </div>

  </form>

  <!-- أزرار التنقل والإرسال -->
  <div class="form-actions">
    <div class="navigation-buttons">
      <button 
        type="button" 
        class="btn-previous" 
        (click)="previousTab()"
        [disabled]="isFirstTab()">
        السابق
      </button>

      <button 
        type="button" 
        class="btn-next" 
        (click)="nextTab()"
        [disabled]="isLastTab()">
        التالي
      </button>
    </div>

    <div class="action-buttons">
      <button type="button" class="btn-cancel" (click)="onCancel()">إلغاء</button>
      <button type="button" class="btn-reset" (click)="onReset()"> Reset
      </button>
      
      <button 
        *ngIf="isLastTab()" 
        type="button" 
        class="btn-save" 
        (click)="onSubmit()">
حفظ - Save      
</button>
    </div>
  </div>
</div>